import { parsePreviewContent } from "./utils";
import { DSNoteDisplay } from "../design-system/organisms/DSNoteDisplay";

const PreviewNoteDisplay = ({
  previewContent,
  isSoap,
  dataTestId,
}) => {
  const parsed = parsePreviewContent(previewContent, isSoap);
  const hasSoapFields = "subjective" in parsed;

  return (
    <DSNoteDisplay
      data={parsed}
      variant={hasSoapFields ? "soap" : "freeform"}
      layout="stacked"
      showAdditionalNotes={false}
      dataTestId={dataTestId}
    />
  );
};

export default PreviewNoteDisplay;
